// extracted by mini-css-extract-plugin
export default {"section":"Panel_section__-FuRf","content":"Panel_content__jDzkx"};